exports = module.exports = require("../../../node_modules/@angular/cli/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/footer/footer.component.css
// module id = ../../../../../src/app/footer/footer.component.css
// module chunks = main